import React, { useState } from "react";
import AddModal from "../../components/AdminPortal/Assignments/AddModal";
import AssignmentRow from "../../components/AdminPortal/Assignments/AssignmentRow";
import { useGetAssignmentsQuery } from "../../features/assignment/assignmentApi";

const Assignments = () => {
  const [opened, setOpened] = useState(false);

  const controlModal = () => {
      setOpened((prevState) => !prevState);
  };

  const { data: assignments, isLoading, isError } = useGetAssignmentsQuery();

  let content;

  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <tr>Something went wrong</tr>;
  }
  if (!isLoading && !isError && assignments.length === 0) {
    content = <tr>No assignment available</tr>;
  }
  if (!isLoading && !isError && assignments.length > 0) {
    content = assignments.map((assignment) => <AssignmentRow key={assignment.id} assignment={assignment} control={controlModal}/>);
  }
  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-full px-5 lg:px-20 relative"> 
      
        <div className="px-3 py-20 bg-opacity-10">
        
          <div className="w-full flex ">
            <button className="btn ml-auto" onClick={controlModal}>Add Assignment</button>
          </div>
         <AddModal open={opened} control={controlModal}/>
          <div className="overflow-x-auto mt-4">
          
            <table className="divide-y-1 text-base divide-gray-600 w-full">
              <thead>
                <tr>
                  <th className="table-th">Title</th>
                  <th className="table-th">Video Title</th>
                  <th className="table-th">Mark</th>
                  <th className="table-th">Action</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-slate-600/50">
                {content}
              </tbody>
            </table>
          </div>
        </div>
      </div>

     
    </section>
  );
};

export default Assignments;
